// Retken aikajanan ryhmittely. Palvelin palauttaa jokaisen uuden ruudun omana
// tapahtumanaan, jotta jokaisen pisteen peruste on jäljitettävissä. Näkymässä
// peräkkäiset ruututapahtumat yhdistetään yhdeksi riviksi, muuten pitkän
// retken aikajana olisi satoja rivejä pelkkiä ruutuja.

const TILE_TYPES = new Set(["tile", "bigtile"]);

/**
 * Palauttaa listan, jonka alkiot ovat joko
 *   { kind: "event", event }  tai
 *   { kind: "tiles", fromT, toT, localDay, small, big, points }.
 * Ryhmä katkeaa muuhun tapahtumaan ja paikallisen päivän vaihtumiseen.
 */
export function groupTimeline(events) {
  const items = [];
  let group = null;
  for (const e of events) {
    if (TILE_TYPES.has(e.type)) {
      if (!group || group.localDay !== e.local_day) {
        group = { kind: "tiles", fromT: e.t, toT: e.t, localDay: e.local_day, small: 0, big: 0, points: 0 };
        items.push(group);
      }
      group.toT = e.t;
      group[e.type === "tile" ? "small" : "big"] += 1;
      group.points += e.points;
    } else {
      group = null;
      items.push({ kind: "event", event: e });
    }
  }
  return items;
}

/** Ryhmän teksti, esim. "9 uutta ruutua ja 2 suurta ruutua". */
export function tileGroupText({ small, big }) {
  const parts = [];
  if (small) parts.push(small === 1 ? "Uusi pikkuruutu" : `${small} uutta pikkuruutua`);
  if (big) parts.push(big === 1 ? "uusi suuri ruutu" : `${big} uutta suurta ruutua`);
  const text = parts.join(" ja ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
